"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChevronRight = function ChevronRight(props) {
  return _react2.default.createElement(
    "svg",
    (0, _extends3.default)({ width: 18, height: 18, viewBox: "0 0 18 18" }, props),
    _react2.default.createElement("path", { d: "M7 11.563v2.617l4.626-5.09L7 4v2.617L9.248 9.09z" })
  );
};

exports.default = ChevronRight;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/icons/ChevronRight.js
// module id = 688
// module chunks = 0